import $ from 'jquery'
import CSVPreviewSection from '../CSVPreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function LeaveCSVPreviewGroupingSection() {}

LeaveCSVPreviewGroupingSection.prototype = new CSVPreviewSection()

LeaveCSVPreviewGroupingSection.prototype.rowsUsersWithMI = [1, 2]

LeaveCSVPreviewGroupingSection.prototype.init = function(firstGroupingLevel, secondGroupingLevel, columnsStrategy, numOfGroupingRows, numOfDataColumns) {
    CSVPreviewSection.prototype.init.call(this)
    this.firstGroupingLevel = firstGroupingLevel
    this.secondGroupingLevel = secondGroupingLevel
    this.columnsStrategy = columnsStrategy
    this.numOfGroupingRows = numOfGroupingRows
    this.numOfDataColumns = numOfDataColumns
    return this
}

LeaveCSVPreviewGroupingSection.prototype.addRows = function(tBody) {
    for (let i = 0; i < 6; i++) {
        let row = this.createRow()
        ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel))
        if (this.secondGroupingLevel !== ReportGroupingLevel.NONE)
            ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel))
        for (let j = 0; j < this.numOfDataColumns; j++)
            this.addTimeValueCell(row)
        this.addRow(tBody, row)
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/leave/LeaveCSVPreviewGroupingSection.js